/**
 * Tool Configuration
 *
 * Centralized config for non-component tool pages
 * (Compatibility Checker, My Check, My Builder).
 * Mirrors the shape of UNIFIED_COMPONENT_CONFIG for consistency.
 */

import type { LucideIcon } from 'lucide-react'
import { ShieldCheck, ListCheck, Blocks } from 'lucide-react'
import type { ThemeColor } from '../types/theme'

export interface ToolConfig {
  label: string
  path: string
  themeColor: ThemeColor
  /** Lucide icon component — pass className to control size (e.g. "w-4 h-4", "w-8 h-8") */
  Icon: LucideIcon
}

export const TOOL_CONFIG = {
  COMPATIBILITY: {
    label: 'Compatibility',
    path: '/compatibility-checker',
    themeColor: 'indigo' as ThemeColor,
    Icon: ShieldCheck,
  },
  MY_CHECK: {
    label: 'My Check',
    path: '/my-check',
    themeColor: 'violet' as ThemeColor,
    Icon: ListCheck,
  },
  MY_BUILDER: {
    label: 'My Builder',
    path: '/my-builder',
    themeColor: 'emerald' as ThemeColor,
    Icon: Blocks,
  },
} satisfies Record<string, ToolConfig>
